module.exports = __webpack_public_path__ + "static/media/hf-users.cd64a0a5.svg";